export default class ElementController {
    #elements = [];

    setElements = elements => {
        this.#elements = elements;
    };

    getElements = () => this.#elements;
}
